// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3412":"a1d9bd30","4860":"05cde06f","4892":"34145634","5735":"d342df2a","6175":"a96e8396","9971":"34145634"}[chunkId] + ".chunk.css";
};